import { createApp } from 'vue';
import GifToJpgConverter from '../Components/GifToJpgConverter.vue';

const root = document.getElementById('gif-to-jpg-converter');
if (root) {
  createApp(GifToJpgConverter).mount('#gif-to-jpg-converter');
}
